<template>
  <div>
    <div>
      <b-jumbotron
        header="🌴UkeAbility"
        lead="It's like butter, but with 4 strings"
      >
        <p>For more information visit website</p>
        <b-button variant="primary" href="#">More Info</b-button>
      </b-jumbotron>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  mounted() {}
};
</script>
